import { globalPlugins } from "../common";
import plugin from "./main";

// @ts-ignore
globalPlugins.push(plugin);

export default plugin;
export * from "./main";
